import dm from "deepmerge";
import { ClientConfigOnChainVoting, CoinType, DatePolicyConfig, } from "../graphql/generated/proposals.sdk";
export const DEFAULT_BRAND = {
    title: "",
    description: "",
    classes: {
        buttons: {
            all: "",
            primary: "",
            secondary: "",
            colored: "",
            tabs: "",
        },
        containers: {
            content: "",
        },
        text: {
            title: "",
            description: "",
        },
    },
    images: {
        audit_pending: "",
        casting_a_vote: "",
        fatal_error: "",
        not_enough_tokens: "",
        proposal_created: "",
    },
};
export const getBrand = (customBrand) => dm(DEFAULT_BRAND, customBrand);
export const DEFAULT_CONFIG = {
    permissions: {
        proposal: [
            {
                policyId: "",
                assetName: "",
                type: CoinType.Token,
                minAmount: "0",
                ticker: "ADA",
            },
        ],
        voting: [
            {
                policyId: "",
                assetName: "",
                type: CoinType.Token,
                minAmount: "0",
                ticker: "ADA",
            },
        ],
    },
    weight: {
        voting: [],
    },
    proposals: {
        audits: {
            defaultAuditor: "SundaeSwap",
        },
        datePolicy: {
            voteStart: {
                type: DatePolicyConfig.Fixed,
                offset: {
                    count: 0,
                    unit: "day",
                },
            },
            voteEnd: {
                type: DatePolicyConfig.Fixed,
                offset: {
                    count: 5,
                    unit: "day",
                },
            },
            voteSnapshot: {
                type: DatePolicyConfig.Fixed,
                offset: {
                    count: 5,
                    unit: "day",
                },
            },
        },
        required_inputs: {
            choices: [
                {
                    name: "Abstain",
                },
            ],
            forumLink: false,
            forumMeta: {
                name: "SundaeSwap",
                prefix: "https://forum.sundaeswap.finance",
            },
        },
    },
    tallies: {
        allowAfter: [],
        allowBefore: [],
    },
    features: {
        custom_options: false,
        onchain_voting: ClientConfigOnChainVoting.Disallow,
    },
};
//# sourceMappingURL=config.js.map